import { cn } from '@/lib/utils';
import { Wifi, WifiOff, Loader2, AlertCircle, Power } from 'lucide-react';

type InboxStatus = 'active' | 'inactive' | 'connecting' | 'error' | 'disconnected';

interface ConnectionStatusBadgeProps {
  status: InboxStatus;
  className?: string;
  showLabel?: boolean;
}

const statusConfig: Record<InboxStatus, {
  label: string;
  icon: typeof Wifi;
  className: string;
  iconClassName: string;
}> = {
  active: {
    label: 'Conectado',
    icon: Wifi,
    className: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
    iconClassName: 'text-green-600 dark:text-green-400',
  },
  inactive: {
    label: 'Inativo',
    icon: Power,
    className: 'bg-muted text-muted-foreground',
    iconClassName: 'text-muted-foreground',
  },
  connecting: {
    label: 'Conectando...',
    icon: Loader2,
    className: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
    iconClassName: 'text-blue-600 dark:text-blue-400 animate-spin',
  },
  error: {
    label: 'Erro',
    icon: AlertCircle,
    className: 'bg-destructive/10 text-destructive',
    iconClassName: 'text-destructive',
  },
  disconnected: {
    label: 'Desconectado',
    icon: WifiOff,
    className: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
    iconClassName: 'text-orange-600 dark:text-orange-400',
  },
};

export function ConnectionStatusBadge({ 
  status, 
  className,
  showLabel = true 
}: ConnectionStatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.inactive;
  const Icon = config.icon;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium',
        config.className,
        className
      )}
    >
      <Icon className={cn('h-3 w-3', config.iconClassName)} />
      {showLabel && <span>{config.label}</span>}
    </div>
  );
}
